import { URLS } from "@app/shared";
import { PageHeader } from "@design-system/components";
import { getCurrentLocaleCode, trans } from "@mongez/localization";

const TOOL_BASE_URL =
  "https://ksatools.eurolandir.com/tools/ee/?companyCode=sa-2240";

export function AnalysisCoveragePage() {
  const locale = getCurrentLocaleCode();
  const toolUrl = `${TOOL_BASE_URL}&lang=${locale === "ar" ? "ar" : "en"}`;

  return (
    <>
      <PageHeader
        translationKey="analystCoverage"
        breadcrumbItems={[
          { label: trans("home"), link: URLS.home },
          { label: trans("investorRelations"), link: URLS.investor.root },
          { label: trans("analystCoverage") },
        ]}
      />
      <div className="container space-y-6 bg-white px-4 py-8 shadow-sm">
        <iframe
          className="euroland-iframe"
          title={trans("analystCoverage")}
          src={toolUrl}
          width="100%"
          height="500"
          scrolling="no"
          frameBorder="0"
        ></iframe>
      </div>
    </>
  );
}
